import HTTPService from "@/core/services/HTTPService";
// import { AxiosResponse } from "axios";
class AuthService {
  /**
   * Получить информацию о текущем пользователе
   * Использует Pinia store через useAuthStore()
   * В статических контекстах лучше вызывать напрямую useAuthStore().me()
   */
  public static async me() {
    // Динамический импорт для избежания циклических зависимостей
    const { useAuthStore } = await import("@/store/pinia/auth");
    const { getActivePinia } = await import("pinia");

    const pinia = getActivePinia();
    if (!pinia) {
      console.warn(
        "Pinia не инициализирована. Используйте useAuthStore().me() в компонентах."
      );
      return;
    }

    const authStore = useAuthStore(pinia);

    if (AuthService.getToken().length > 0) {
      await authStore.me();
    }
  }

  public static removeToken() {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
  }

  public static getToken(): string {
    return localStorage.getItem("token") ?? "";
  }

  /*
  login(email: string, password: string) {
    const urn = "/auth/login";
    const data = { email, password };

    return ApiService.httpRequest.post(urn, data);
  }

  logout() {
    const urn = "/auth/logout";
    return ApiService.httpRequest.post(urn);
  }

  signup(
    email: string,
    password: string,
    passwordConfirm: string,
    name: string
  ) {
    const urn = "/auth/signup";
    const data = { email, password, passwordConfirm, name };

    return ApiService.httpRequest.post(urn, data);
  }

  isAuthorized(): boolean {
    return this.getToken().length > 0;
  }

  getToken(): string {
    return localStorage.getItem("token") ?? "";
  }

  getEmail(): string {
    return localStorage.getItem("email") ?? "";
  }

  showMenu() {
    return this.isAuthorized();
  }

  setToken() {
    ApiService.createRequestHandler();
  }



  updateLocalStorage(responseServer: AxiosResponse, email: string) {
    if (
      responseServer.data.data &&
      typeof responseServer.data.data.accessToken !== "undefined"
    ) {
      localStorage.setItem("token", responseServer.data.data.accessToken);
      localStorage.setItem("email", email);

      const sessionBackUrl = sessionStorage.getItem("backUrl");

      return sessionBackUrl !== null ? sessionBackUrl : "/";
    }

    return null;
  }

  hideNonAuthSection(): boolean {
    const currentName = router.currentRoute.value.name;
    return currentName == "login" || currentName == "signup";
  }*/
}

export default AuthService;
